export default "__VITE_ASSET__tsxt6kUy__"